import {Component, OnInit} from '@angular/core';
import {Auth} from "../app.auth";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    auth: Auth;

    constructor(auth: Auth) {
        this.auth = auth;
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts